import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { getRoute } from "utils/routing";

export default function ProposalDraftRedirectPage() {
  const { proposalId } = useParams();
  const [searchParams] = useSearchParams();
  const query = searchParams.toString();
  const draftRoute = getRoute("proposals.draft", [["proposalId", proposalId ?? ""]]);

  return <Navigate to={`${draftRoute}${query ? `?${query}` : ""}`} replace />;
}
